import { MainLoader, ResourceLoader, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonalInfoResourceInfo } from '../PersonalInformationResource/PersonalInformationResource';
import Content from './Content';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { StyledTile } from './ConsentTile.styles';

export interface ConsentTileProps { }

const ConsentTile: FC<ConsentTileProps> = () => {
  const { t } = useTranslation('ConsentTile');
  const personalInfo: PersonalInformation = useScopedSelector(PersonalInfoResourceInfo.dataDst);
  if (!personalInfo?.consent?.uci) return null;
  if (personalInfo?.consent?.consents?.length === 0) return null;
  return (
    <StyledTile data-testid="consentTile" title={t('title')} isDivided>
      <ResourceLoader
        inlineErrorMessage={false}
        buttonAlign="left"
        autoRequest
        resourceSrc={PersonalInfoResourceInfo.name}
        CustomLoader={MainLoader}
      >
        <Content personalInfo={personalInfo} />
      </ResourceLoader>
    </StyledTile>
  );
};

export default ConsentTile;
